define('models/shared/qanda/question_collection',["backbone",
     "models/shared/qanda/question"
], function (Backbone, question) {
    return Backbone.Collection.extend({
        url: function () {
            if (this.instanceURL)
                return this.instanceURL;
            return pf.consumerURL + "/OutOfWallet";
        },
        model: question,
        initialize: function (options) {
           // this.instanceURL = options.instanceURL;
        }
    });
});
